"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var redux_observable_1 = require("redux-observable");
var operators_1 = require("rxjs/operators");
var networkStatusSlice_1 = require("../networkStatusSlice/networkStatusSlice");
/**
 * This epic will listen to all actions that have updateRequestStatus.type as their type,
 * and will reset the network status associated with the action's id to "initial".
 *
 * Some pages (like the login screen) need to listen to the network status for the
 * provided request perform a redirect logic (example: login screen will listen
 * for the 'success' network status to redirect us to the dashboard). To prevent this
 * page from becoming inaccessible once the request finishes, we need to dispatch another
 * action which sets the network status as 'initial' for that id.
 *
 * Take this into consideration when depending on network states
 */
var networkStatusResetEpic = function (action$) {
    return action$.pipe(redux_observable_1.ofType(networkStatusSlice_1.updateRequestStatus.type), operators_1.filter(function (action) {
        return ['success', 'failure'].includes(action.payload.status);
    }), operators_1.map(function (action) {
        return networkStatusSlice_1.updateRequestStatus({ id: action.payload.id, status: 'initial' });
    }));
};
exports.default = networkStatusResetEpic;
//# sourceMappingURL=networkStatusResetEpic.js.map